export const formatDate = (value: string): string => {
  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleString("en-US", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatAmount = (value: string): string => {
  const amount = Number(value);
  return Number.isNaN(amount) ? value : amount.toFixed(2);
};

export const formatAddress = (value: string | null | undefined): string => {
  if (value == null || value === "") {
    return "—";
  }

  if (value.length <= 14) {
    return value;
  }

  return `${value.slice(0, 8)}…${value.slice(-6)}`;
};
